import React, { useState, useEffect } from 'react';
import { UserPlus, X } from 'lucide-react';

const SEEN_KEY = 'signUpTabShown';

// Small sign-up tab: shows once per visit after scrolling, hides itself after 8 seconds.
const FloatingSignUp = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('user_data') || sessionStorage.getItem(SEEN_KEY)) return undefined;
    let timer;
    const onScroll = () => {
      if (window.scrollY < 500) return;
      window.removeEventListener('scroll', onScroll);
      sessionStorage.setItem(SEEN_KEY, 'true');
      setVisible(true);
      timer = setTimeout(() => setVisible(false), 8000);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => { window.removeEventListener('scroll', onScroll); clearTimeout(timer); };
  }, []);

  if (!visible) return null;

  return (
    <div data-testid="floating-signup-tab" className="fixed bottom-4 left-4 z-40 hidden md:flex items-center gap-1 rounded-full bg-black/80 backdrop-blur-md border border-white/10 pl-3 pr-1 py-1 text-xs text-neutral-200 shadow-lg animate-in fade-in slide-in-from-bottom-2 duration-300">
      <button
        onClick={() => { setVisible(false); window.dispatchEvent(new CustomEvent('openAuthModal', { detail: { mode: 'signup' } })); }}
        data-testid="floating-signup-btn"
        className="flex items-center gap-1.5 hover:text-white transition-colors duration-200"
      >
        <UserPlus size={14} /> Sign up for credits
      </button>
      <button onClick={() => setVisible(false)} data-testid="floating-signup-close" aria-label="Close" className="p-1 rounded-full text-neutral-500 hover:text-white transition-colors duration-200">
        <X size={12} />
      </button>
    </div>
  );
};

export default FloatingSignUp;
